import React, { FunctionComponent, useEffect, useState } from 'react';

import { useFetch } from '@api/ApiHelper';
import { ContentAutomationGetResponse } from '@api/v4/assets/contentAutomations';

export interface RenderEditorProps {
  digest: string;
}

const getAssetKeyFromUrl = (): string => {
  const url = window.location.href;
  return url ? new URL(url).pathname.split('/').pop() : '';
};

const buildUrl = (digest): string => {
  var url = null;
  if (digest) {
    url = `/api/v4/assets/${getAssetKeyFromUrl()}/content_automations?digest=${digest}`;
  } else {
    url = `/api/v4/assets/${getAssetKeyFromUrl()}/content_automations`;
  } 
  return url;
};

const showError = (): void => {
  Notify.create({
    title: bfTranslate('There was an error fetching the template. Please try again.'),
    type: 'error'
  });
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const RenderEditor: FunctionComponent<RenderEditorProps> = ({ digest }) => {
  const [templateEditorUrl, setTemplateEditorUrl] = useState('');

  const getTemplateEditorUrl = useFetch<ContentAutomationGetResponse>({
    url: buildUrl(digest),
  });

  useEffect(() => {
    if (getTemplateEditorUrl.response) {
      setTemplateEditorUrl(
        getTemplateEditorUrl.response.data.attributes.template_editor_url
      );
    }
  }, [getTemplateEditorUrl.response]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (getTemplateEditorUrl.error) {
      showError();
    }
  }, [getTemplateEditorUrl.error]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    templateEditorUrl &&
    <iframe className="renderedEditor" src={templateEditorUrl} title={bfTranslate('Content Automation')}></iframe>
  );
};
